export default {
  // Navigation
  nav: {
    home: 'Accueil',
    about: 'À propos',
    contact: 'Contact',
    admin: 'Administration',
    backToHome: '← Retour à l\'accueil'
  },

  // Page d'accueil (Upload)
  home: {
    title: 'ProTransfert',
    subtitle: 'Partagez vos fichiers en toute sécurité',
    aboutLink: 'À propos de ProTransfert',
    contactLink: 'Nous contacter',
    uploadTitle: 'Glissez-déposez votre fichier',
    uploadSubtitle: 'ou cliquez pour sélectionner un fichier',
    clickToUpload: 'Cliquez pour téléverser',
    dragAndDrop: 'ou glissez-déposez',
    maxSize: 'Taille maximale',
    removeFile: 'Supprimer et choisir un autre fichier',
    recipientEmail: 'Email du destinataire',
    recipientEmailPlaceholder: 'destinataire@exemple.com',
    message: 'Message (optionnel)',
    messagePlaceholder: 'Ajoutez un message pour le destinataire...',
    uploadButton: 'Envoyer le fichier',
    uploading: 'Envoi en cours...',
    uploadSuccess: 'Fichier envoyé avec succès !',
    uploadError: 'Erreur lors de l\'envoi du fichier'
  },

  // Page À propos
  about: {
    title: 'À propos de ProTransfert',
    subtitle: 'La solution française de transfert de fichiers sécurisé, conçue pour les entreprises et les professionnels exigeants.',
    madeInFrance: 'Fabriqué en France',
    madeInFranceSubtitle: 'Développé et hébergé en France',
    features: {
      security: {
        title: 'Sécurité maximale',
        description: 'Chiffrement de bout en bout, authentification sécurisée et protection contre les accès non autorisés.'
      },
      speed: {
        title: 'Transfert ultra-rapide',
        description: 'Optimisé pour des transferts de fichiers volumineux avec une vitesse maximale.'
      },
      interface: {
        title: 'Interface intuitive',
        description: 'Interface moderne et responsive, accessible depuis tous les appareils.'
      },
      rgpd: {
        title: 'Conforme RGPD',
        description: 'Respect total du Règlement Général sur la Protection des Données européen.'
      },
      management: {
        title: 'Gestion avancée',
        description: 'Suivi des téléchargements, notifications par email et contrôle d\'accès.'
      },
      support: {
        title: 'Support français',
        description: 'Support technique en français, disponible pour vous accompagner.'
      }
    },
    rgpd: {
      title: 'Conformité RGPD',
      subtitle: 'ProTransfert respecte scrupuleusement le Règlement Général sur la Protection des Données',
      yourRights: 'Vos droits',
      ourCommitments: 'Nos engagements',
      rights: {
        access: 'Droit d\'accès à vos données',
        rectification: 'Droit de rectification',
        erasure: 'Droit à l\'effacement',
        portability: 'Droit à la portabilité'
      },
      commitments: {
        encryption: 'Chiffrement des données',
        hosting: 'Hébergement en France',
        deletion: 'Suppression automatique',
        noSharing: 'Aucun partage de données'
      }
    },
    madeInFranceSection: {
      title: '🇫🇷 Fabriqué en France',
      subtitle: 'Une solution 100% française pour vos transferts de fichiers',
      development: {
        title: 'Développement français',
        description: 'Conçu et développé par des équipes françaises'
      },
      hosting: {
        title: 'Hébergement français',
        description: 'Données hébergées sur le territoire français'
      },
      support: {
        title: 'Support français',
        description: 'Équipe de support technique française'
      }
    },
    footer: '© 2024 ProTransfert - Solution française de transfert de fichiers sécurisé'
  },

  // Page Contact
  contact: {
    title: 'Contactez-nous',
    subtitle: 'Notre équipe française est là pour vous accompagner. N\'hésitez pas à nous contacter pour toute question sur ProTransfert.',
    form: {
      name: 'Nom complet *',
      namePlaceholder: 'Votre nom complet',
      email: 'Email *',
      emailPlaceholder: 'votre@email.com',
      company: 'Entreprise',
      companyPlaceholder: 'Nom de votre entreprise',
      phone: 'Téléphone',
      phonePlaceholder: 'Votre numéro de téléphone',
      subject: 'Sujet *',
      subjectPlaceholder: 'Sujet de votre demande',
      message: 'Message *',
      messagePlaceholder: 'Décrivez votre demande en détail...',
      characters: 'caractères',
      submit: 'Envoyer le message',
      sending: 'Envoi en cours...',
      success: 'Votre demande a été envoyée avec succès. Vous recevrez une confirmation par email.',
      error: 'Erreur de connexion. Veuillez réessayer.'
    },
    validation: {
      nameRequired: 'Le nom est requis',
      nameMinLength: 'Le nom doit contenir au moins 2 caractères',
      emailRequired: 'L\'email est requis',
      emailInvalid: 'L\'email n\'est pas valide',
      subjectRequired: 'Le sujet est requis',
      subjectMinLength: 'Le sujet doit contenir au moins 5 caractères',
      messageRequired: 'Le message est requis',
      messageMinLength: 'Le message doit contenir au moins 10 caractères',
      messageMaxLength: 'Le message ne peut pas dépasser 1000 caractères'
    },
    info: {
      email: {
        title: 'Email',
        value: 'contact@protransfert.com'
      },
      location: {
        title: 'Localisation',
        value: 'France'
      },
      response: {
        title: 'Réponse',
        value: 'Sous 24-48h'
      }
    },
    rgpd: {
      title: 'Protection des données',
      description: 'Vos données personnelles sont collectées uniquement pour traiter votre demande de contact. Elles ne seront pas partagées avec des tiers et seront supprimées après traitement. Conformément au RGPD, vous disposez d\'un droit d\'accès, de rectification et d\'effacement de vos données.'
    }
  },

  // Page de confirmation
  confirm: {
    title: 'Fichier envoyé avec succès !',
    subtitle: 'Votre fichier a été partagé avec succès.',
    downloadLink: 'Lien de téléchargement',
    copyLink: 'Copier le lien',
    linkCopied: 'Lien copié !',
    shareViaEmail: 'Partager par email',
    emailSent: 'Email envoyé !',
    expiration: 'Ce lien expirera le',
    newUpload: 'Envoyer un autre fichier'
  },

  // Page de téléchargement
  download: {
    title: 'Téléchargement de fichier',
    downloadButton: 'Télécharger le fichier',
    downloading: 'Téléchargement en cours...',
    fileNotFound: 'Fichier non trouvé',
    fileExpired: 'Ce fichier a expiré',
    fileSize: 'Taille du fichier',
    uploadedBy: 'Partagé par',
    uploadedOn: 'Partagé le',
    expiresOn: 'Expire le',
    message: 'Message',
    noMessage: 'Aucun message'
  },

  // Admin
  admin: {
    dashboard: {
      title: 'Tableau de bord',
      connectedAs: 'Connecté en tant que',
      files: 'Fichiers',
      companies: 'Entreprises',
      users: 'Utilisateurs',
      stats: 'Statistiques'
    }
  },

  // Authentication
  auth: {
    login: {
      title: 'Connexion',
      subtitle: 'Connectez-vous à votre compte ProTransfert',
      email: 'Email',
      emailPlaceholder: 'votre@email.com',
      password: 'Mot de passe',
      passwordPlaceholder: 'Votre mot de passe',
      login: 'Se connecter',
      loggingIn: 'Connexion en cours...',
      or: 'ou',
      googleSignIn: 'Se connecter avec Google',
      dontHaveAccount: 'Vous n\'avez pas de compte ?',
      signUp: 'S\'inscrire',
      error: 'Erreur de connexion',
      googleAuthFailed: 'Échec de l\'authentification Google'
    },
    register: {
      title: 'Inscription',
      subtitle: 'Créez votre compte ProTransfert',
      name: 'Nom complet',
      namePlaceholder: 'Votre nom complet',
      email: 'Email',
      emailPlaceholder: 'votre@email.com',
      password: 'Mot de passe',
      passwordPlaceholder: 'Votre mot de passe',
      confirmPassword: 'Confirmer le mot de passe',
      confirmPasswordPlaceholder: 'Confirmez votre mot de passe',
      register: 'S\'inscrire',
      registering: 'Inscription en cours...',
      or: 'ou',
      googleSignUp: 'S\'inscrire avec Google',
      alreadyHaveAccount: 'Vous avez déjà un compte ?',
      signIn: 'Se connecter',
      passwordMismatch: 'Les mots de passe ne correspondent pas',
      passwordTooShort: 'Le mot de passe doit contenir au moins 6 caractères',
      error: 'Erreur d\'inscription'
    },
    callback: {
      authenticating: 'Authentification en cours...',
      pleaseWait: 'Veuillez patienter',
      error: 'Erreur d\'authentification',
      noToken: 'Aucun token d\'authentification reçu',
      verificationFailed: 'Échec de la vérification du token',
      backToLogin: 'Retour à la connexion'
    },
    welcome: 'Bienvenue',
    logout: 'Déconnexion'
  },

  // Messages généraux
  common: {
    loading: 'Chargement...',
    error: 'Une erreur est survenue',
    success: 'Opération réussie',
    cancel: 'Annuler',
    save: 'Enregistrer',
    delete: 'Supprimer',
    edit: 'Modifier',
    close: 'Fermer',
    yes: 'Oui',
    no: 'Non',
    required: 'Requis',
    optional: 'Optionnel'
  }
} 